import React from 'react';
import AsyncPage from './async';
import DefaultConsumerLayout from '../../../../components/layout/DefaultConsumerLayout';

export default [
  <DefaultConsumerLayout
    key="/consumer/features/double-chin-remover"
    exact
    path="/consumer/features/double-chin-remover"
    component={AsyncPage}
  />,
];
